import React from 'react';
import dati from './dati/ViniDati.json';
import './App.css';
import Navigation from './navigation';
import Menu from './components/menu';



function App() {
  const trenta = dati.Trenta;
  const sagr = dati.Sagrantino;
  

  return (
    <>
    <Menu/>
    <Navigation/>
    
    </>    
  );
}

export default App;